import { useContext, useEffect, useState } from 'react'

import Axios from 'axios';
import { Col, Form, Row, Table } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import DashboardContext from '../../../Context';
import Loader from '../../layout/Loader';
import Pagination from '../props/Pagination';
import SearchFrom from '../SearchFrom';

import '../tabel.css'
import ExcelExport from '../ExcelExport';
import TabelbodyFinance from './TabelbodyFinance';
import PaidPaymentreceipt from './PaidPaymentreceipt';
import SendSmsModal from './SendSmsModal';

/**
 * این کامپوننت جدول امور مالی است
 */

export default function TabelFinance({ urldata, arryactions, isnoid, isCheck, showform, handelShowForm, FormTabel }) {

    const { sideBardata,
        authentication,
        urldashboard,
        handelloding,
        idview,
        dataFromTabel,
        handelerrors,
        walletupdate,
        setOffSearchLoding,
        searchLoading
    } = useContext(DashboardContext);

    const { location } = useHistory()

    const [dataFech, setDataFech] = useState({})

    const [startpage, setStartpage] = useState(JSON.parse(sessionStorage.getItem('startpageProps')) || 1)

    const [pageSize, setPageSize] = useState(JSON.parse(sessionStorage.getItem('pageSizeProps')) || 10)

    const [serch, setSerch] = useState(JSON.parse(sessionStorage.getItem('serchProps')) || '')

    const [deleteitem, setDeleteitem] = useState(false)

    const [loader, setLoader] = useState(true)


    const [inputvalue, setInputvalue] = useState("")





    const datafeching = async (startpage, pageSize, serch) => {
        let formdata = {}
        if (isnoid) {
            formdata = {
                "page": parseInt(startpage),
                "pageSize": parseInt(pageSize),
                "search": serch,
                userId: JSON.parse(sessionStorage.getItem('workerId')) ? JSON.parse(sessionStorage.getItem('workerId')) : JSON.parse(sessionStorage.getItem('customerid')) ? JSON.parse(sessionStorage.getItem('customerid')) : idview
            }

        }
        else {
            formdata = {
                "page": parseInt(startpage),
                "pageSize": parseInt(pageSize),
                "search": serch,
                ...dataFromTabel
            }
        }



        try {
            const res = await Axios.post(`${urldashboard}${urldata}/get`, JSON.stringify(formdata), {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json"
                }
            })

            const data = await res.data;
            setOffSearchLoding(false);
            setDataFech(data)
            setLoader(false)
            handelloding(false)
        } catch (error) {
            handelloding(false)
            setOffSearchLoding()
            handelerrors(error)

        }
    }


    useEffect(() => {
        datafeching(startpage, pageSize, serch)
        return () => {

        }
    }, [startpage, pageSize, serch, location.pathname, deleteitem, walletupdate, dataFromTabel,searchLoading])

    //logic serch start
    const handelserchinput = e => {
        if (e.target.value) {
            setInputvalue(e.target.value)
        }
        else {
            setInputvalue("")
            sessionStorage.setItem('serchProps', JSON.stringify(''))
            setSerch('')
            sessionStorage.setItem('startpageProps', JSON.stringify(1))
            sessionStorage.setItem('PaginationProps', JSON.stringify([]))

            setStartpage(1)
        }
    }

    const handelserch = (e) => {
        e.preventDefault()

        if (inputvalue) {
            sessionStorage.setItem('serchProps', JSON.stringify(inputvalue));
            setSerch(inputvalue);
            setLoader(true);
            sessionStorage.setItem('startpageProps', JSON.stringify(1));
            sessionStorage.setItem('PaginationProps', JSON.stringify([]));
            setStartpage(1);
        }
    }
    //logic serch end


    const handeldeleteitem = () => {
        setLoader(true)
        setDeleteitem(!deleteitem)
    }



    //logic Pagination start
    const handelpagenumber = (number) => {
        sessionStorage.setItem('startpageProps', JSON.stringify(number))
        setStartpage(number)
    }

    const handelprevpage = () => {
        if (parseInt(dataFech.page) === 1) {

        }
        else {
            sessionStorage.setItem('startpageProps', JSON.stringify(startpage - 1))
            setStartpage(startpage - 1)
        }
    }

    const handelNextpage = () => {
        if (dataFech.page === dataFech.totalPage) {

        }
        else {
            sessionStorage.setItem('startpageProps', JSON.stringify(startpage + 1))
            setStartpage(startpage + 1)
        }
    }
    //logic Pagination end

    const arryrowpage = [10, 20, 50, 100, 500]
    const handelrowPage = e => {
        setPageSize(parseInt(e.target.value))
        sessionStorage.setItem('pageSizeProps', JSON.stringify(parseInt(e.target.value)))
        sessionStorage.setItem('startpageProps', JSON.stringify(1))
        sessionStorage.setItem('PaginationProps', JSON.stringify([]))

        setStartpage(1)
        setLoader(true)
    }

    /// handelList

    const [checkList, setCheckList] = useState([])

    const handelCheckBox = (event) => {

        if (event.target.checked) {

            setCheckList([...checkList, event.target.value])

        }
        else {

            setCheckList(checkList.filter(find => find !== event.target.value))
        }

    }
    const [Allselect, setAllselect] = useState(false);

    const handelAllSelect = () => {

        let itemarry = [];

        [...document.querySelectorAll('.FinanceCheck')].map(item => {

            if (!Allselect) {
                item.checked = true
                itemarry.push(item.value)
            }
            else {
                item.checked = false
                itemarry = []
            }
        })

        setCheckList(itemarry)

        setAllselect(!Allselect)
    }

    const [showmodalSms, setShowmodalSms] = useState(false);

    const handelSendSms = () => setShowmodalSms(true);

    const handelCloseModalSms = () => setShowmodalSms(false);



    const [showModal, setShowModal] = useState(false)

    const handelShowModal = () => setShowModal(true)

    const handelCloseModal = () => setShowModal(false)


    return (
        <>
            {
                sideBardata.length > 0 ?
                    <>

                        < Row className='mb-3 mt-3' >
                            <SearchFrom
                                handelserchinput={handelserchinput}
                                handelserch={handelserch} />

                            <Col md={6} sm={6} xs={12}  >

                                <div className='d-flex justify-content-end mt-sm-0 mt-lg-0 mt-3' >
                                    {
                                        showform ?
                                            <button className={FormTabel ? 'btn btn-danger ml-3' : 'btn btn-success ml-3'} onClick={handelShowForm} >
                                                {FormTabel ?
                                                    "بستن فرم و پاک کردن جستجو" : "جستجو پیشرفته"}
                                            </button>
                                            : null
                                    }
                                    {
                                        dataFech.hasOwnProperty("data") ?
                                            isCheck ?
                                                location.pathname === '/AccountBalance' ?
                                                    <button type="button"
                                                        disabled={checkList.length > 0 ? false : true}
                                                        className="btn btn-primary btn-icon-text btn-sm ml-3" onClick={handelSendSms} > ارسال پیام گروهی </button>
                                                    :
                                                    <button type="button"
                                                        disabled={checkList.length > 0 ? false : true}
                                                        onClick={handelShowModal}
                                                        className="btn btn-primary btn-icon-text btn-sm ml-3">
                                                        پرداخت گروهی
                                                    </button>
                                                : null
                                            : null
                                    }

                                    {
                                        dataFech.hasOwnProperty("data") ?
                                            <ExcelExport data={dataFech.data}
                                                headers={dataFech.headers.map(item => item.label)}
                                                filename={location.pathname.slice(1, location.pathname.length)} />
                                            : null
                                    }
                                </div>

                            </Col>
                        </ Row>
                        {
                            !loader ?

                                dataFech.data.length > 0 ?

                                    <>
                                        <div className='table-responsive tabeldata'  >
                                            <Table hover bordered  >
                                                <thead>
                                                    <tr>
                                                        <th  >
                                                            {
                                                                isCheck ?
                                                                    <i style={{ cursor: 'pointer' }} onClick={handelAllSelect} class="mdi mdi-arrange-bring-forward"></i>
                                                                    : '#'
                                                            }
                                                        </th>
                                                        {dataFech.headers.length > 10 ?
                                                            dataFech.headers.slice(0, 10).map(item =>
                                                            (item.name === 'id' ? <th key={item.name}>ردیف</th> : item.name === "transactionStatus" ? null : <th key={item.name} >
                                                                {item.label}
                                                            </th>))
                                                            : dataFech.headers.map(item =>
                                                            (item.name === 'id' ? <th key={item.name}>ردیف</th> : item.name === "transactionStatus" ? null : <th key={item.name} >
                                                                {item.label}
                                                            </th>))
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dataFech.data.map((item, index) => (
                                                        <TabelbodyFinance
                                                            arryheder={dataFech.headers.length > 10 ? dataFech.headers.slice(10, dataFech.headers.length) : []}
                                                            page={startpage}
                                                            key={item.id}
                                                            item={item}
                                                            number={index}
                                                            urldata={urldata}
                                                            handeldeleteitem={handeldeleteitem}
                                                            arryactions={arryactions}
                                                            isCheck={isCheck}
                                                            handelCheckBox={handelCheckBox}
                                                            deleteitem={deleteitem}
                                                        />
                                                    ))
                                                    }
                                                </tbody>
                                            </Table>
                                        </div>
                                        <Row className='mt-3 mb-5' >
                                            <Col md={5} sm={6} xs={12}
                                                className='d-flex align-items-baseline' >

                                                <Pagination
                                                    totalPage={dataFech.totalPage}
                                                    page={dataFech.page}
                                                    handelprevpage={handelprevpage}
                                                    handelNextpage={handelNextpage}
                                                    handelpagenumber={handelpagenumber}
                                                />

                                            </Col>
                                            <Col md={4} sm={3} xs={6}
                                                className='d-flex align-items-end d-sm-block mt-sm-2' >
                                                <div className='d-flex ml-auto mr-sm-auto ' >
                                                    <p>مجموع کل : </p>
                                                    <span className='mr-2'>{" "}
                                                        {dataFech.totalRecord}{" "}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col md={3} sm={3} xs={6}
                                                className='mt-sm-0 mt-3 mt-md-0'  >
                                                <div className='rowminger' >
                                                    <p className='text-nowrap' >تعداد ردیف :</p>
                                                    <Form.Control size="sm" as="select"
                                                        onChange={handelrowPage}  >
                                                        {
                                                            arryrowpage.map(item =>
                                                            (<option key={item}
                                                                selected={item === pageSize ?
                                                                    true :
                                                                    false}
                                                                value={item} >{item}</option>))
                                                        }

                                                    </Form.Control>
                                                </div>
                                            </Col>
                                        </Row>
                                    </>

                                    : " چیزی یافت نشد :("


                                : <Loader />
                        }
                    </>
                    : <Loader />

            }
            {
                showModal ?
                    <PaidPaymentreceipt
                        show={showModal}
                        handelCloseModal={handelCloseModal}
                        dataform={checkList}
                        handelrelod={handeldeleteitem}
                    />
                    : null
            }
            {
                showmodalSms ?
                    <SendSmsModal
                        show={showmodalSms}
                        handelCloseModal={handelCloseModalSms}
                        dataform={checkList}
                        handelrelod={handeldeleteitem}
                    />
                    : null
            }
        </>)
}
